import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

const IOSSwitch = styled((props) => (
  <Switch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    {...props}
  />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#65C466',
        opacity: 1,
        border: 0,
        ...theme.applyStyles('dark', {
          backgroundColor: '#2ECA45',
        }),
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
      ...theme.applyStyles('dark', {
        color: theme.palette.grey[600],
      }),
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
      ...theme.applyStyles('dark', {
        opacity: 0.3,
      }),
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
    ...theme.applyStyles('dark', {
      backgroundColor: '#39393D',
    }),
  },
}));

const PreferenceSwitchBox = ({ switchItems }) => {
  const [menuItems, setMenuItems] = useState(
    switchItems.map((item) => ({
      label: item,
      checked: false,
    })),
  );

  const handleSwitchChange = (index) => {
    setMenuItems((prevItems) => prevItems.map((item, i) => (i === index ? { ...item, checked: !item.checked } : item)));
  };

  return (
    <Box
      id="preference-switch-box-main-container"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '8px',
        alignSelf: 'stretch',
        borderRadius: '8px',
        border: '2px solid var(--color4, #EDEDED)',
      }}
    >
      <Box
        id="preference-switch-box-container"
        sx={{
          display: 'flex',
          padding: '20px 16px 16px 16px',
          flexDirection: 'column',
          alignItems: 'flex-end',
          gap: '18px',
          alignSelf: 'stretch',
          borderRadius: '12px',
          background: 'var(--color1, #FCFCFC)',
        }}
      >
        <Box
          id="preference-switch-box-container-part-2"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '13px',
            alignSelf: 'stretch',
          }}
        >
          {menuItems.map((item, index) => (
            <Box
              id="switch-container"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '18px',
                alignSelf: 'stretch',
              }}
              key={index}
            >
              <Box
                id="switch-label-container"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  flex: '1 0 0',
                }}
              >
                <Typography
                  sx={{
                    color: 'var(--color12, #171717)',
                    textAlign: 'right',
                    leadingTrim: 'both',
                    textEdge: 'cap',
                    fontFamily: 'Montserrat',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    fontWeight: 700,
                    lineHeight: 'normal',
                  }}
                >
                  {item.label}
                </Typography>
              </Box>
              <Box
                id="switcher-box-container"
                sx={{
                  display: 'flex',
                  padding: '0px',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  gap: '0px',
                }}
              >
                <IOSSwitch
                  checked={item.checked}
                  onChange={() => handleSwitchChange(index)}
                />
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default PreferenceSwitchBox;
